import type { RailwayColumn, RailwayFilters } from "../types";

export const RAILWAY_API = "/railway-query";
export const SEAT_COLUMNS: { key: RailwayColumn; lines: string[]; filter: string }[] = [
  { key: "SWZ", lines: ["商务座", "特等座"], filter: "商务座" },
  { key: "D", lines: ["优选", "一等座"], filter: "优选一等座" },
  { key: "ZY", lines: ["一等座"], filter: "一等座" },
  { key: "ZE", lines: ["二等座", "二等包座"], filter: "二等座" },
  { key: "GR", lines: ["高级", "软卧"], filter: "高级软卧" },
  { key: "RW", lines: ["软卧/动卧", "一等卧"], filter: "软卧/一等卧" },
  { key: "YW", lines: ["硬卧", "二等卧"], filter: "硬卧/二等卧" },
  { key: "RZ", lines: ["软座"], filter: "软座" },
  { key: "YZ", lines: ["硬座"], filter: "硬座" },
  { key: "WZ", lines: ["无座"], filter: "无座" },
  { key: "QT", lines: ["其他"], filter: "其他" },
];
export const TRAIN_TYPES = [
  { value: "GC", label: "GC-高铁/城际" }, { value: "D", label: "D-动车" },
  { value: "Z", label: "Z-直达" }, { value: "T", label: "T-特快" },
  { value: "K", label: "K-快速" }, { value: "other", label: "其他" },
];

/** 创建互不共享数组的空筛选条件。 */
export function emptyFilters(): RailwayFilters {
  return { trainTypes: [], features: [], origins: [], destinations: [], seats: [], departure: "00:00-24:00", discounted: false, exchange: false, bookable: false };
}
